import { ContentArea } from "./ContentArea.js";
import { jsx } from "react/jsx-runtime";

//#region src/client/components/shared/ConsentCheckboxLabel.tsx
const ConsentCheckboxLabel = ({ consent }) => {
	return /* @__PURE__ */ jsx(ContentArea, {
		checkbox: true,
		contents: consent.publishedConsentBox?.htmlContent ?? ""
	});
};

//#endregion
export { ConsentCheckboxLabel };